module.exports = __webpack_public_path__ + "img/freeSendMobilePage.727f6045.jpg";